import type { BuilderState, Engine } from "../builder-state";
import * as postgres from "./postgres";
import * as mysql from "./mysql";
import * as oracle from "./oracle";
import * as mssql from "./mssql";
import * as mongo from "./mongo";
import * as db2 from "./db2";
import type { ConnectionString, DialectCapabilities } from "./shared";

export { isSafeIdent } from "./shared";
export type { ConnectionString, DialectCapabilities } from "./shared";

export interface Dialect {
  id: Engine;
  label: string;
  defaultPort: number;
  caps: DialectCapabilities;
  generate: (s: BuilderState) => string;
  connectionStrings: (s: BuilderState) => ConnectionString[];
}

const make = (id: Engine, m: Omit<Dialect, "id">): Dialect => ({ id, ...m });

export const dialects: Record<Engine, Dialect> = {
  postgres: make("postgres", postgres),
  mysql: make("mysql", mysql),
  oracle: make("oracle", oracle),
  mssql: make("mssql", mssql),
  mongo: make("mongo", mongo),
  db2: make("db2", db2),
};

/** Engines in the order they should appear in the UI selector. */
export const engineList: Dialect[] = [
  dialects.postgres,
  dialects.mysql,
  dialects.oracle,
  dialects.mssql,
  dialects.mongo,
  dialects.db2,
];

export function generate(state: BuilderState): string {
  return dialects[state.engine].generate(state);
}

export function connectionStrings(state: BuilderState): ConnectionString[] {
  return dialects[state.engine].connectionStrings(state);
}

export function defaultPortFor(engine: Engine): number {
  return dialects[engine].defaultPort;
}

export function capsFor(engine: Engine): DialectCapabilities {
  return dialects[engine].caps;
}
